import { IRange, ITerrainRunsData } from 'api/resort/types';

export const formatPercentVal = (val: number | undefined | null, fallback: string = '-') => {
  if (typeof val === 'undefined' || val === null) {
    return fallback;
  }
  // eslint-disable-next-line no-mixed-operators
  return `${val.toFixed(0)}%`;
};

export const formatPercent = (val: IRange | undefined, fallback: string = '-') => {
  if (typeof val === 'undefined' || typeof val.open === 'undefined' || typeof val.total === 'undefined' || val.total === 0) {
    return fallback;
  }
  // eslint-disable-next-line no-mixed-operators
  return formatPercentVal((100 * val.open / val.total));
};

export const formatTerrainPercent = (val: ITerrainRunsData | undefined, fallback: string = '-') => {
  if (typeof val === 'undefined' || typeof val.totalPercent === 'undefined' || val.totalPercent === 0) {
    return fallback;
  }
  // eslint-disable-next-line no-mixed-operators
  return `${val.totalPercent}%`;
};
